import { Link, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import loginStateAtom from '../atoms/loginStateAtom';
// import { unregister } from '../registerServiceWorker';
import logo from '../assets/icons/ev-logo.png'
import home from '../assets/icons/home.png'
import profile from '../assets/icons/my_profile.png'
import appointment from '../assets/icons/appointment.png';
import specialEquipmentIcon from '../assets/icons/special_equipment.png';
import leave from '../assets/icons/leave.png';
import manual from '../assets/icons/manuals.png';
import training from '../assets/icons/training.png';
import chatsupport from '../assets/icons/chatsupport.png';
import workEstimate from '../assets/icons/work_estimate.png'
import signout from '../assets/icons/signout.png'
import { useState } from 'react';
import ConfirmationModal from './ConfirmationModal';
import PaymentMode from './PaymentMode';
import { url, app_version } from '../utils/config';



function Menu(props) {
    const [ loggedIn, setLoggedIn ] = useRecoilState(loginStateAtom);
    const [ showModal, setShowModal ] = useState(false)
    const navigate = useNavigate()

    function logout() {
        window.localStorage.clear();
        setLoggedIn(false);
        navigate('/');
        // unregister()
    }

    return(
        <div className={`flex fixed h-screen  top-0 left-0 overflow-hidden rounded-md z-50 transition-all duration-5 0 ease-in-out ${props.showMenu ? 'w-full' : 'w-0'}`} onClick={() => props.setShowMenu(false)}>
            {
                showModal &&
                <ConfirmationModal
                    header={'Sign Out'}
                    body={'Are you sure you want to sign out?'}
                    cancelHandler={setShowModal}
                    confirmHandler={logout}
                />
            }
            <div className='flex flex-col w-2/3 bg-white justify-between'>
                <div className='flex flex-col px-2 '>
                    <div className='flex items-center px-2 py-4 gap-6'>
                        {/* <img src={props.uiConfig?.logos?.landingLogo ? url + '/images/' + props.uiConfig.logos.landingLogo : logo} height={10} width={80}/> */}
                    </div>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/'>
                        <span><img src={home} height={20} width={20} /></span>
                        <span className=''>Home</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/profile'>
                        <span><img src={profile} height={20} width={20} /></span>
                        <span>Profile</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/appointment'>
                        <span><img src={appointment} height={20} width={20} /></span>
                        <span>Appointment</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/special_equipments'>
                        <span><img src={specialEquipmentIcon} height={20} width={20} /></span>
                        <span>Special Equipment</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/leave'>
                        <span><img src={leave} height={20} width={20} /></span>
                        <span>Leave</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/faqs'>
                        <span><img src={manual} height={20} width={20} /></span>
                        <span>Roll & ChatGPT</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/manual_list'>
                        <span><img src={manual} height={20} width={20} /></span>
                        <span>Manuals</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/trainings' >
                        <span><img src={training} height={20} width={20} /></span>
                        <span>Trainings</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/support' >
                        <span><img src={chatsupport} height={20} width={20} className='text-gray-500' /></span>
                        <span>Support</span>
                    </Link>
                    {/* <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/payment-mode'>
                        <span><img src={training} height={20} width={20} /></span>
                        <span>Payment Mode</span>
                    </Link>
                    <Link className='py-3 px-4 flex items-center gap-2 hover:text-blue-600 hover:bg-blue-200' to='/payment-confirmation'>
                        <span><img src={training} height={20} width={20} /></span>
                        <span>Payment Confirmation</span>
                    </Link> */}

                </div>
                <div onClick={() => setShowModal(true)} className='flex items-center justify-between mb-16 py-4 px-3 border-t border-gray-400 cursor-pointer hover:text-blue-600 hover:bg-blue-200'>
                    <div onClick={() => setShowModal(true)}>Sign Out</div>
                    <img src={signout} width={20} height={20} />
                </div>
                <div className='absolute bottom-4 left-3 text-gray-500 text-xs'>{app_version}</div>
            </div>
            <div className='flex-1 bg-black opacity-50' onClick={() => props.setShowMenu(false)}></div>
        </div>
    )
}

export default Menu;